module.exports = __webpack_public_path__ + "static/support-01-9a9207a629babb3e03ae19f3d130e499.png";